import { api as apiProvider } from '@/core/api/';
import _generalApi from '@/modules/app/api';

const baseApiURL = 'api/beca';

export const getSearchResult = (searchModel) =>
  apiProvider.get(`${baseApiURL}/card/search`, { params: searchModel });
export const getEvidenceDocumentSearchResult = (params) =>
  apiProvider.get(`${baseApiURL}/card/evidencedocument`, { params });
export const deleteEvidenceDocument = (documentId) =>
  apiProvider.put(`${baseApiURL}/card/evidencedocument/${documentId}`);
export const postClaim = (claimModel) =>
  apiProvider.post(`${baseApiURL}/card/addclaim`, claimModel);
export const putReceived = (receivedModel) =>
  apiProvider.put(`${baseApiURL}/card/updatereception`, receivedModel);
export const putSingleReceived = (singleReceivedModel) =>
  apiProvider.put(
    `${baseApiURL}/card/updatesinglereception`,
    singleReceivedModel
  );
export const putDelivered = (deliveredModel) =>
  apiProvider.put(`${baseApiURL}/card/updatedeliver`, deliveredModel);
export const putArchived = (archivedModel) =>
  apiProvider.put(`${baseApiURL}/card/updatearchive`, archivedModel);
export const putCancellation = (cancellationModel) =>
  apiProvider.put(`${baseApiURL}/card/cancellation`, cancellationModel);
export const postManagement = (managementModel) =>
  apiProvider.post(`${baseApiURL}/card/addcardmanagement`, managementModel);
export const getManagement = (becaCardId) =>
  apiProvider.get(`${baseApiURL}/card/cardmanagement/${becaCardId}`);
export const deleteManagement = (id) =>
  apiProvider.put(`${baseApiURL}/card/deletecardmanagement/${id}`);
export const putCseeDelivery = (requestModel) =>
  apiProvider.put(`${baseApiURL}/card/updatecseedelivery`, requestModel);
export const putCardBankRequest = (requestModel) =>
  apiProvider.put(`${baseApiURL}/card/updatecardbankrequest`, requestModel);
export const putCardReturn = (model) =>
  apiProvider.put(`${baseApiURL}/card/updatecardreturn`, model);
export const downloadCardDeliveryReport = async (params) => {
  return await apiProvider
    .get(`${baseApiURL}/carddeliverydownload`, { params: params })
    .then((res) => {
      const result = res.data;
      if (result) {
        _generalApi.documentDownloadReport(result.content, result.filename);
      }
    });
};
export const getStudentHasCard = (studentSieId) =>
  apiProvider.get(`${baseApiURL}/card/student/${studentSieId}/hascard`);
export const addCard = (cardModel) => {
  return apiProvider.post(`${baseApiURL}/card`, cardModel);
};
export const getCardHistory = (cardId) =>
  apiProvider.get(`${baseApiURL}/card/history/${cardId}`);
export const getStudentLocationSchoolForCard = (studentSieId) =>
  apiProvider.get(`${baseApiURL}/card/studentlocation/${studentSieId}`);
